import styled from 'styled-components';
import { global } from '../../../shared/colors';

const InspectionText = styled.p`
    color: ${global.textGrey};
    margin-bottom: 40px;
    background: ${global.Gray6};
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default InspectionText;
